<template>
  <div>
    <div v-for="g in 3" :key="g" class="mb-7 last:mb-0">
      <skeleton width="90px" height="12px" rounded="4px" class-name="mb-2.5 ml-1"></skeleton>
      <div class="bg-white border border-black/6 rounded-[20px] shadow-[0_2px_12px_rgba(0,0,0,0.04)] overflow-hidden">
        <div v-for="i in (g === 1 ? 4 : g === 2 ? 3 : 2)" :key="i" class="flex gap-3 py-3.5 px-5 border-b border-black/4 last:border-b-0">
          <skeleton width="30px" height="30px" rounded="50%" class-name="shrink-0 mt-0.5"></skeleton>
          <div class="flex-1 min-w-0">
            <div class="flex items-center gap-2 mb-1.5">
              <skeleton width="70px" height="13px" rounded="4px"></skeleton>
              <skeleton width="140px" height="13px" rounded="4px"></skeleton>
            </div>
            <div class="flex items-center gap-2.5 mt-1.5">
              <skeleton width="90px" height="11px" rounded="4px"></skeleton>
              <skeleton width="50px" height="11px" rounded="4px"></skeleton>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Skeleton from './Skeleton'

export default {
  name: 'SkeletonActivities',
  components: { Skeleton }
}
</script>
